/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	child: {
		marginTop: token('space.050'),
		marginRight: token('space.050'),
		marginBottom: token('space.050'),
		marginLeft: token('space.050'),
		minWidth: 0,
	},
	option: {
		alignItems: 'center',
		display: 'flex',
	},
	item: {
		display: 'flex',
	},
	childIcon: {
		marginLeft: token('space.100'),
	},
	optionIcon: {
		borderRadius: token('radius.full'),
		height: '16px',
		width: '16px',
		display: 'flex',
		marginTop: token('space.025'),
		marginRight: token('space.025'),
		marginBottom: token('space.025'),
		marginLeft: token('space.025'),
	},
});

export const StyledChild = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.child} {...props}>
		{children}
	</div>
);

export const StyledOption = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.option} {...props}>
		{children}
	</div>
);

export const StyledItem = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.item} {...props}>
		{children}
	</div>
);

export const StyledChildIcon = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.childIcon} {...props}>
		{children}
	</div>
);

export const StyledOptionIcon = ({
	alt = '',
	...props
}: React.ComponentPropsWithoutRef<'img'>): React.JSX.Element => (
	<img css={styles.optionIcon} alt={alt} {...props} />
);
